import { AppIcon } from './AppIcon'

export type ReviewModeIconMode = 'free' | 'scheduled'

export function ReviewModeIcon({ mode }: { mode: ReviewModeIconMode }) {
  if (mode === 'free') {
    return <AppIcon className="review-mode-icon is-free" name="loop" />
  }

  return <span aria-hidden="true" className="review-mode-icon is-scheduled" />
}
